import FieldSet from '../../FieldSet';

import { StatusName } from './StatusName';
import { StatusPill } from './StatusPill';
import { StatusIcon } from './StatusIcon';
import { StatusLabel } from './StatusLabel';
import { TimeInStatus } from './TimeInStatus';

export class StatusFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [StatusName, StatusPill, StatusLabel, StatusIcon, TimeInStatus];
  }

  get title() {
    return 'Status';
  }
}
